export default [
  {
    fullName: 'АЛЕКСЕЙ ВАСИЛЬЕВ',
    jobTitle: 'Генеральный продюсер Flowcon, Россия <a href="#" target="_blank">Ссылка</a>',
    description: 'Имеет 16 лет в вебе во всех его проявлениях — от фронтенда до CI, от e-commerce до edtech. Считает, что фронтенд сложнее бэкенда (но это не точно).'
  },
  {
    fullName: 'ТАТЬЯНА КРОС',
    jobTitle: 'Системный аналитик Гигатех, Россия <a href="#" target="_blank">Ссылка</a>',
    description: 'Имеет 16 лет в вебе во всех его проявлениях — от фронтенда до CI, от e-commerce до edtech. Считает, что фронтенд сложнее бэкенда (но это не точно).'
  },
  {
    fullName: 'РОМАН ПАНИН',
    jobTitle: 'Руководитель группы развития BI-систем Пандикс, Россия <a href="#" target="_blank">Ссылка</a>',
    description: 'Имеет 16 лет в вебе во всех его проявлениях — от фронтенда до CI, от e-commerce до edtech. Считает, что фронтенд сложнее бэкенда (но это не точно).'
  },
  {
    fullName: 'ВЕРОНИКА ЖЕЛНОВА',
    jobTitle: 'Автор нескольких курсов по разработке и управлению требованиями, управлению проектами, разработке и документированию системной архитектуры. Предприниматель, Россия <a href="#" target="_blank">Ссылка</a>',
    description: 'Имеет 16 лет в вебе во всех его проявлениях — от фронтенда до CI, от e-commerce до edtech. Считает, что фронтенд сложнее бэкенда (но это не точно).'
  },
  {
    fullName: 'ИВАН САПРАНОВ',
    jobTitle: 'Product Analyst SpostmasterLab, Армения <a href="#" target="_blank">Ссылка</a>',
    description: 'Имеет 16 лет в вебе во всех его проявлениях — от фронтенда до CI, от e-commerce до edtech. Считает, что фронтенд сложнее бэкенда (но это не точно).'
  },
  {
    fullName: 'Оксана Вельмитаминова',
    jobTitle: 'Заместитель председателя, член правления банка "Вперед, и точка!", Россия <a href="#" target="_blank">Ссылка</a>',
    description: 'Имеет 16 лет в вебе во всех его проявлениях — от фронтенда до CI, от e-commerce до edtech. Считает, что фронтенд сложнее бэкенда (но это не точно).'
  }
]
